import { useMemo } from "react"
import { useQueryAdapter } from "shared-ts/adapters"
import { adaptListUnitsOfMeasureForCompany } from "shared-ts/libs/product/unitsOfMeasure.adapter"
import { UnitOfMeasure } from "shared-ts/libs/product/unitsOfMeasure.types"

import { useListUnitsOfMeasureForCompanyQuery } from "features/api/company"

const EMPTY_UNITS_OF_MEASURE: UnitOfMeasure[] = []

export function useGetCompanyUnitsOfMeasure(filterActive: boolean = true) {
  const query = useListUnitsOfMeasureForCompanyQuery({
    filterActive: filterActive,
  })

  const { data } = useQueryAdapter({
    query: query,
    adapter: adaptListUnitsOfMeasureForCompany,
    defaultValue: EMPTY_UNITS_OF_MEASURE,
  })

  const companyUnitsOfMeasureById = useMemo(
    () => new Map<string, UnitOfMeasure>(data.map((u) => [u.id.toString(), u])),
    [data]
  )

  return {
    companyUnitsOfMeasure: data,
    companyUnitsOfMeasureById,
    isError: query.isError,
    isLoading: query.isLoading,
  }
}
